import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import {
  Role,
  Form,
  FormHeader,
  FormFooter,
  FormBack,
  FormNext,
  DateElement,
  CheckboxesElement,
} from "cw-styleguide-react";
import i18n from "../../../../i18n";
import withAssets from "../../../../components/hoc/withAssets";
import { STEP_SESSION_CREATE, STEP_SESSION_CONTACT, STEP_SESSION_VIEW, ROLE_PROVIDER, ROLE_STAFF } from "../../../../constants";
import CoursesSessionsFormProgress from "../CoursesSessionsFormProgress";
import ErrorNavigation from '../../../../components/ErrorNavigation';
import WysiwygElement from '../../../../components/WysiwygElement';

class SessionsDetailsStep extends Component {

  render() {
    const newSessionTitle = this.props.t('local:view.courses.create.tabs.sessions.step.details.title');
    const existingSessionTitle = newSessionTitle + ': ' + this.props.t('local:misc.session') + ' ' + this.props.sessionId;

    return (
      <div id={'sessions.' + this.props.sessionId}>
        <Form multi={true}>
          <ErrorNavigation field={this.props.errorActiveField} handleClearActiveErrors={this.props.handleClearActiveErrors} />
          <CoursesSessionsFormProgress step={this.props.step} handleSetStep={this.props.handleSetStep} isEditing={!!this.props.loadedSessionUuid} />
          <FormHeader title={this.props.sessionId ? existingSessionTitle : newSessionTitle}>
            <Role roles={[ROLE_STAFF]}>
              <p dangerouslySetInnerHTML={{ __html: this.props.t('local:view.courses.create.tabs.courseDetails.mandatoryPromptStaff') }} />
            </Role>
            <Role roles={[ROLE_PROVIDER]}>
              <p dangerouslySetInnerHTML={{ __html: this.props.t('local:view.courses.create.tabs.sessions.step.details.mandatoryPromptProvider') }} />
            </Role>
          </FormHeader>
          <p className={'h3'}>{this.props.t('local:view.courses.create.tabs.sessions.step.details.fieldset.schedule.label')}</p>

          {/* Start date */}
          <div id={'sessions.' + this.props.sessionId + '.startDate'} />
          <DateElement
            id={'startDate'}
            name={'startDate'}
            label={this.props.t('local:view.courses.create.tabs.sessions.step.details.field.startDate.label')}
            description={this.props.t('local:view.courses.create.tabs.sessions.step.details.field.startDate.description')}
            value={this.props['startDate']}
            errors={this.props.errors['sessions.' + this.props.sessionId + '.startDate']}
            onChange={this.props.handleChange} />

          {/* Start details */}
          <div id={'sessions.' + this.props.sessionId + '.startDetails_' + this.props.inputLanguage} />
          <WysiwygElement
            id={'startDetails_' + this.props.inputLanguage}
            name={'startDetails_' + this.props.inputLanguage}
            label={this.props.t('local:view.courses.create.tabs.sessions.step.details.field.startDetails.label')}
            description={this.props.t('local:view.courses.create.tabs.sessions.step.details.field.startDetails.description')}
            value={this.props['startDetails_' + this.props.inputLanguage]}
            errors={this.props.errors['sessions.' + this.props.sessionId + '.startDetails_' + this.props.inputLanguage]}
            onChange={(e) => this.props.handleSet('startDetails_' + this.props.inputLanguage, e.data.get())} />

          {/* Days and times */}
          <div id={'sessions.' + this.props.sessionId + '.daysTimes_' + this.props.inputLanguage} />
          <WysiwygElement
            id={'daysTimes_' + this.props.inputLanguage}
            name={'daysTimes_' + this.props.inputLanguage}
            label={this.props.t('local:view.courses.create.tabs.sessions.step.details.field.daysAndTimes.label')}
            description={this.props.t('local:view.courses.create.tabs.sessions.step.details.field.daysAndTimes.description')}
            value={this.props['daysTimes_' + this.props.inputLanguage]}
            errors={this.props.errors['sessions.' + this.props.sessionId + '.daysTimes_' + this.props.inputLanguage]}
            onChange={(e) => this.props.handleSet('daysTimes_' + this.props.inputLanguage, e.data.get())} />

          <p className={'h3'}>{this.props.t('local:view.courses.create.tabs.sessions.step.details.fieldset.studyMethods.label')}</p>
          <p>{this.props.t('local:view.courses.create.tabs.sessions.step.details.fieldset.studyMethods.description')}</p>

          {/* Study method type */}
          <div id={'sessions.' + this.props.sessionId + '.studyMethodType'} />
          <CheckboxesElement
            id={'studyMethodType'}
            name={'studyMethodType'}
            label={this.props.t('local:view.courses.create.tabs.sessions.step.details.field.studyMethodType.label')}
            options={this.props.courses.assets.courses.studyMethodType[i18n.language]}
            value={this.props['studyMethodType']}
            errors={this.props.errors['sessions.' + this.props.sessionId + '.studyMethodType']}
            onChange={this.props.handleChange}
            required={true} />

          {/* Study method hours */}
          <CheckboxesElement
            id={'studyMethodHours'}
            name={'studyMethodHours'}
            label={this.props.t('local:view.courses.create.tabs.sessions.step.details.field.studyMethodHours.label')}
            options={this.props.courses.assets.courses.studyMethodHours[i18n.language]}
            value={this.props['studyMethodHours']}
            onChange={this.props.handleChange} />

          {/* Study method times */}
          <CheckboxesElement
            id={'studyMethodTimes'}
            name={'studyMethodTimes'}
            label={this.props.t('local:view.courses.create.tabs.sessions.step.details.field.studyMethodTimes.label')}
            options={this.props.courses.assets.courses.studyMethodTimes[i18n.language]}
            value={this.props['studyMethodTimes']}
            onChange={this.props.handleChange} />

          <FormFooter>
            {this.props.sessions.length === 0 &&
              <FormBack
                onClick={(e) => {
                  this.props.handleSetStep(e, STEP_SESSION_CREATE);
                  this.props.handleScrollTop();
                }} />
            }
            {this.props.sessions.length > 0 &&
              <FormBack
                onClick={(e) => {
                  this.props.handleSetStep(e, STEP_SESSION_VIEW);
                  this.props.handleClearSession();
                  this.props.handleScrollTop();
                }}>
                {this.props.t('local:view.courses.create.tabs.sessions.callToAction')}
              </FormBack>
            }
            <FormNext
              onClick={(e) => {
                this.props.handleSetStep(e, STEP_SESSION_CONTACT);
                this.props.handleScrollTop();
              }} />
          </FormFooter>
        </Form>
      </div>
    );
  }

}

export default withAssets(withTranslation('local')(SessionsDetailsStep));
